import { AxiosApiClient } from '$utils/apiClient'
import { cookiesStorage } from '$utils/services/cookiesStorage'
import encryptService from '$utils/services/encryptService'
import { AxiosRequestConfig } from 'axios'

export class FamiliadosApiClient extends AxiosApiClient {
  constructor() {
    super(
      process.env.REACT_APP_API_BASE_URL as string,
      {
        username: process.env.REACT_APP_BASIC_AUTH_USER,
        password: process.env.REACT_APP_BASIC_AUTH_PASS,
      },
      true,
    )
    this.getDefaultHeaders()
  }

  getToken = () => {
    const token = encryptService().decrypt(cookiesStorage.getCookie('token'))
    const userToken = cookiesStorage.getCookie('user_token')

    if (token && userToken) {
      return userToken
    }
    if (token && !userToken) {
      return token
    }
    return ''
  }

  getDefaultHeaders(): void {
    const token = this.getToken()
    const defaultHeaders = this.instance.defaults.headers
    if (token !== '') {
      this.instance.defaults.headers = {
        ...defaultHeaders,
        token,
      }
    }
  }

  get<P>(path: string, params?: any, options?: AxiosRequestConfig): Promise<P> {
    this.getDefaultHeaders()
    return super.get(path, params, options)
  }

  post<P>(path: string, data?: any): Promise<P> {
    this.getDefaultHeaders()
    return super.post(path, data)
  }

  patch<P>(path: string, data?: any): Promise<P> {
    this.getDefaultHeaders()
    return super.patch(path, data)
  }

  delete<P>(path: string, data?: any): Promise<P> {
    this.getDefaultHeaders()
    return super.delete(path, data)
  }
}

export default new FamiliadosApiClient()



// WEBPACK FOOTER //
// ./src/utils/familiadosApiClient.ts